import api from '@/lib/api';
import { API_ENDPOINTS } from '@/constants/endpoints';
import type { ApiResponse } from '@/types';

/** One field a settings save changed. */
export interface SettingsChange {
	/** Dotted path within the setting, e.g. `holdMessage.enabled`. */
	path: string;
	before: unknown;
	after: unknown;
}

/** One settings change, from kim-ai's or machine's audit log, as merged by the backend (settingsLog.service.ts). */
export interface SettingsLogEntry {
	id: string;
	at: string;
	/** The setting's name for brand settings, or the area, e.g. "Intent automation". */
	area: string;
	/** The intent or channel it was about, when there is one. */
	subject: string | null;
	operation: 'create' | 'update' | 'delete';
	/** An account-wide change, which applies to every brand. */
	allBrands: boolean;
	actor: { type: 'user' | 'system'; name: string | null; email: string | null };
	changes: SettingsChange[];
}

export interface SettingsLogFilter {
	/** ISO instants: at or after `from`, before `to`. */
	from?: string;
	to?: string;
}

export const settingsLogService = {
	/** A page of the brand's settings changes, newest first; `before` is the last page's `nextBefore`. */
	async fetchPage(filter: SettingsLogFilter, before: string | undefined, scope: { bu_id?: string }) {
		const res = await api.get<ApiResponse<{ entries: SettingsLogEntry[]; hasMore: boolean; nextBefore: string | null }>>(API_ENDPOINTS.SETTINGS_LOGS.LIST, {
			params: { ...scope, ...filter, ...(before && { before }), limit: 25 }
		});
		return res.data.data;
	}
};
